import './scss/index.scss';
import { dcFactory } from 'dc';
import FundraiserTotaliserComponent from './js/fundraiser-totaliser.component';

dcFactory.register(FundraiserTotaliserComponent);
